<template>
    <v-data-table
      :headers="headers"
      :items="listado">
      <template
        v-slot:[`item.tipo`]="{ item }">
        {{ getTipo(item.tipo) }}
      </template>
      <template
        v-slot:[`item.fechaAlta`]="{ item }">
        <v-chip
          v-if="item.fechaAlta"
          color="success">
          <v-icon
            left
            small>
            mdi-arrow-up
          </v-icon>
          <!-- {{ item.fechaAlta }} -->
          {{ $moment(item.fechaAlta).format('D/M/YYYY') }}
        </v-chip>
      </template>
      <template
        v-slot:[`item.fechaBaja`]="{ item }">
        <v-chip
          v-if="item.fechaBaja"
          color="warning">
          <v-icon
            left
            small>
            mdi-arrow-down
          </v-icon>
          <!-- {{ item.fechaBaja }} -->
          {{ $moment(item.fechaBaja).format('D/M/YYYY') }}
        </v-chip>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip
        top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip
        top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
    </template>
    </v-data-table>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoListadoInsumos',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
      headers: [
        {
          text: 'Tipo',
          align: 'start',
          sortable: false,
          value: 'tipo',
        },
        {
          text: 'Nombre',
          align: 'start',
          sortable: false,
          value: 'nombre',
        },
        {
          text: 'Puesto',
          align: 'start',
          sortable: false,
          value: 'puesto',
        },
        {
          text: 'Organización',
          align: 'start',
          sortable: false,
          value: 'organizacion',
        },
        {
          text: 'Dato de contacto',
          align: 'start',
          sortable: false,
          value: 'contacto',
        },
        {
          text: 'Fecha Alta',
          align: 'start',
          sortable: false,
          value: 'fechaAlta',
        },
        {
          text: 'Fecha Baja',
          align: 'start',
          sortable: false,
          value: 'fechaBaja',
        },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    getTipo(tipo) {
      switch (tipo) {
        case 'cliente': return 'Cliente';
        case 'Contratista': return 'Contratista';
        case 'supervision-externa': return 'Supervisión externa';
        default: return 'Otro';
      }
    },
    editar(directorio) {
      eventBus.$emit('editar-directorio-contrato', directorio);
    },
    borrar(frente) {
      eventBus.$emit('eliminar-frente-contrato', frente);
    },
  },
};
</script>

<style lang="scss">

</style>
